import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 接口及正式分流规则确认前，保险流程仅通过独立预览入口验收。
  {
    path: '/insurance-preview',
    name: 'InsuranceFlowPreview',
    component: () => import('../views/insurance/preview.vue'),
    meta: { title: '保险申请流程预览' },
  },
  // 微信内部进件跳转的下载页面
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/download'),
    meta: {
      title: '领取额度',
    },
  },
  // 协议页面
  {
    path: '/protocol',
    name: 'Protocol',
    component: () => import('../views/protocol'),
    meta: {
      title: '协议',
    },
  }, // 协议列表页面
  {
    path: '/protocolList/:channelCode?',
    name: 'ProtocolList',
    component: () => import('../views/protocolList'),
    meta: {
      title: '协议列表',
    },
  },
  // 404页面
  {
    path: '/404',
    name: 'NoPage',
    component: () => import('../views/404'),
    meta: {
      title: '404',
    },
  },
  // 产品推荐结果页面
  {
    path: '/productRecomed',
    name: 'ProductRecomed',
    component: () => import('../views/productRecomed'),
    meta: {
      title: '产品推荐',
    },
  },
  // 了解闪借花介绍页面
  {
    path: '/know',
    name: 'Know',
    component: () => import('../views/know'),
    meta: {
      title: '了解闪借花',
    },
  },
  // 配合登录10
  {
    path: '/registerEntry_tl5',
    name: 'RegisterEntryTl5',
    component: () => import('../views/entryPages/registerEntry_tl5'),
    meta: {
      title: '草船借钱',
    },
  },
  // 配合登录10
  {
    path: '/registerEntry_tl5_themeOne',
    name: 'RegisterEntryTl5ThemeOne',
    component: () => import('../views/entryPages/registerEntry_tl5_themeOne'),
    meta: {
      title: '草船借钱',
    },
  },
  // 配合登录10
  {
    path: '/entry_orange',
    name: 'EntryOrange',
    component: () => import('../views/entryPages/entry_orange'),
    meta: {
      title: '闪借花',
    },
  },
  // 配合身份认证
  {
    path: '/entry_identity',
    name: 'EntryIdentity',
    component: () => import('../views/entryPages/entry_identity'),
    meta: {
      title: '身份信息',
    },
  },
  // review流程进件页面
  {
    path: '/entry_review',
    name: 'EntryReview',
    component: () => import('../views/entryPages/entry_review'),
    meta: {
      title: '闪借花',
    },
  },
  // review城市判断流程进件页面
  {
    path: '/entry_reviewCity',
    name: 'EntryReviewCity',
    component: () => import('../views/entryPages/entry_reviewCity'),
    meta: {
      title: '闪借花',
    },
  },
  // 配合登录10
  {
    path: '/entry_sjh',
    name: 'EntrySjh',
    component: () => import('../views/entryPages/entry_sjh'),
    meta: {
      title: '闪借花',
    },
  },
  // 独立入口供后台配置勾选协议模板，不影响原进件模板。
  {
    path: '/entry_sjh_agree',
    name: 'EntrySjhAgree',
    component: () => import('../views/entryPages/entry_sjh_agree'),
    meta: {
      title: '闪借花',
    },
  },
  // 930 页面文件独立维护，访问地址保持一级路径以适配 H5 渠道链接。
  {
    path: '/entry',
    name: 'Apply930Entry',
    component: () => import('../views/apply930/entry.vue'),
    meta: {
      title: '闪借花',
    },
  },
  {
    path: '/result',
    name: 'Apply930Result',
    component: () => import('../views/apply930/result.vue'),
    meta: {
      title: '申请结果',
    },
  },
  // 旧预览链接直接落到一级地址，保留渠道参数并清除地址栏中的 apply930。
  {
    path: '/apply930/entry',
    redirect: to => ({ path: '/entry', query: to.query, hash: to.hash }),
  },
  {
    path: '/apply930/result',
    redirect: to => ({ path: '/result', query: to.query, hash: to.hash }),
  },
  // 新版进件表单页
  {
    path: '/entry_sjh4',
    name: 'EntrySjh4',
    component: () => import('../views/entryPages/entry_sjh4'),
    meta: {
      title: '闪借花',
    },
  },
  // 配合登录10
  {
    path: '/entry_sjh2',
    name: 'EntrySjh2',
    component: () => import('../views/entryPages/entry_sjh2'),
    meta: {
      title: '闪借花',
    },
  },
  // 配合登录10
  {
    path: '/entry_chjq',
    name: 'EntryChjq',
    component: () => import('../views/entryPages/entry_chjq'),
    meta: {
      title: '草船借钱',
    },
  },
  // 三方签约结果
  {
    path: '/triContract',
    name: 'TriContract',
    component: () => import('../views/triContract'),
    meta: {
      title: '三方签约结果',
    },
  },
  // 此路由为不同项目域名的演示流程进件页面（不调接口）
  {
    path: '/interProRegisterEntry',
    name: 'InterProRegisterEntry',
    component: () => import('../views/interProRegisterEntry'),
    meta: {
      // 合规调整：路由标题不再承诺固定办理时限。
      title: '借款申请',
    },
  },
  // IOS下载引导页
  {
    path: '/iosDownIntroductionPage',
    name: 'IosDownIntroductionPage',
    component: () => import('../views/iosDownIntroductionPage'),
    meta: {
      title: 'IOS下载引导页',
    },
  },
  // 此路由为不同项目域名的演示流程完成（不调接口）
  {
    path: '/interProPassedSuccess',
    name: 'InterProPassedSuccess',
    component: () => import('../views/interProPassedSuccess'),
    meta: {
      // 合规调整：路由标题不再承诺固定办理时限。
      title: '借款申请',
    },
  },
  // 此路由为贷超产品跳转中间页面路由
  {
    path: '/convenientEntrance',
    name: 'ConvenientEntrance',
    component: () => import('../views/convenientEntrance'),
    meta: {
      title: '产品推荐',
    },
  },
  // 活动
  {
    path: '/activity',
    name: 'Activity',
    meta: {
      title: '',
    },
    component: () => import('../views/activity'),
    children: [
      // 转盘活动页面
      {
        path: 'turntable',
        name: 'Turntable',
        component: () => import('../views/activity/turntable'),
        meta: {
          title: '幸运大转盘',
        },
      },
      {
        path: 'turntable/rule',
        name: 'TurntableRule',
        component: () => import('../views/activity/turntable/rule'),
        meta: {
          title: '活动规则',
        },
      },
      {
        path: 'turntable/prize',
        name: 'TurntablePrize',
        component: () => import('../views/activity/turntable/prize'),
        meta: {
          title: '我的奖品',
        },
      },
    ],
  },
  // H5唤醒APP,
  {
    path: '/openApp',
    name: 'OpenApp',
    component: () => import('../views/liftingAPP/openApp'),
    meta: {
      title: '打开闪借花',
    },
  },
  // 借款结果页主题1
  {
    path: '/result_loan_themeOne',
    name: 'ResultLoanThemeOne',
    component: () => import('../views/resultPages/result_loan_themeOne'),
    meta: {
      title: '下载闪借花',
    },
  },
  // 半进件-城市拦截/Loading结果页
  {
    path: '/result_half_loan_loading',
    name: 'ResultHalfLoanLoading',
    component: () => import('../views/resultPages/result_half_loan_loading'),
    meta: {
      title: '信息评估',
    },
  },
  // H5下载页，点击按钮跳应用市场,
  {
    path: '/downloadApp',
    name: 'DownloadApp',
    component: () => import('../views/liftingAPP/downloadApp'),
    meta: {
      title: '下载闪借花',
    },
  },
  // 借款结果页主题2
  {
    path: '/result_loan_themeTwo',
    name: 'ResultLoanThemeTwo',
    component: () => import('../views/resultPages/result_loan_themeTwo'),
    meta: {
      title: '下载闪借花',
    },
  },
  // H5下载页主题1，点击按钮跳应用市场,
  {
    path: '/downloadApp_themeOne',
    name: 'DownloadAppThemeOne',
    component: () => import('../views/liftingAPP/downloadApp_themeOne'),
    meta: {
      title: '下载闪借花',
    },
  },
  // H5下载页主题2，点击按钮跳应用市场,
  {
    path: '/downloadApp_themeTwo',
    name: 'DownloadAppThemeTwo',
    component: () => import('../views/liftingAPP/downloadApp_themeTwo'),
    meta: {
      title: '下载闪借花',
    },
  },
  // 闪借花plus下载页面,
  {
    path: '/downloadApp_themeThree',
    name: 'DownloadAppThemeThree',
    component: () => import('../views/liftingAPP/downloadApp_themeThree'),
    meta: {
      title: '下载闪借花',
    },
  },
  // 进件结果页面(引导接听电话下载页-带外呼号码)
  {
    path: '/trialSuccess_tl3',
    name: 'TrialSuccessTl3',
    component: () => import('../views/resultPages/trialSuccess_tl3'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 进件结果页面(引导接听电话下载页-带外呼号码)
  {
    path: '/result_orange',
    name: 'ResultOrange',
    component: () => import('../views/resultPages/result_orange'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 联登全流程进件结果页面
  {
    path: '/result_union',
    name: 'ResultUnion',
    component: () => import('../views/resultPages/result_union'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 新主题进件结果页面(引导接听电话下载页-带外呼号码)
  {
    path: '/result_orange_themeOne',
    name: 'ResultOrangeThemeOne',
    component: () => import('../views/resultPages/result_orange_themeOne'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 半流程联登进件结果页面
  {
    path: '/result_half_union',
    name: 'ResultHalfUnion',
    component: () => import('../views/resultPages/result_half_union'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 撞库成功结果页（多产品可勾选 + 协议 Tab，对齐 public/result_zk_suc.html）
  {
    path: '/result_zk_suc_comn',
    name: 'ResultZkSucComn',
    component: () => import('../views/resultPages/result_zk_suc_comn'),
    meta: {
      title: '初审结果',
    },
  },
  // 进件结果页面(引导接听电话下载页-带外呼号码)
  {
    path: '/result_sjh',
    name: 'ResultSjh',
    component: () => import('../views/resultPages/result_sjh'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 进件结果页面(引导接听电话下载页-带外呼号码)
  {
    path: '/result_sjh2',
    name: 'ResultSjh2',
    component: () => import('../views/resultPages/result_sjh2'),
    meta: {
      title: '等待电话审核',
    },
  },
  // 进件结果页面(引导接听电话下载页-带外呼号码)
  {
    path: '/result_cchjq',
    name: 'ResultCchjq',
    component: () => import('../views/resultPages/result_cchjq'),
    meta: {
      title: '等待电话审核',
    },
  },
  // H5还款计划
  {
    path: '/repaymentPlan',
    name: 'RepaymentPlan',
    component: () => import('../views/repaymentPlan'),
    meta: {
      title: '还款计划',
    },
  },
  // 会员权益页面
  {
    path: '/member',
    name: 'Member',
    component: () => import('../views/member'),
    meta: {
      title: '会员',
    },
  },
  // 联登半流程进入页面
  {
    path: '/combinedHalf',
    name: 'combinedHalf',
    component: () => import('../views/combinedHalf/entryHalf.vue'),
    meta: {
      title: '闪借花',
    },
  },
  // 联登半流程进件结果页面（url中有jumpUrl会默认5s跳走，没有jumpUrl则不会默认跳走，页面展示包含贷超流程，下载、我知道了按钮，底部产品等；如果只想要一个结果页面，默认跳走的话component选successHalf.vue组件就可以）
  {
    path: '/combinedHalfSuccess',
    name: 'combinedHalfSuccessGoProduct',
    component: () => import('../views/combinedHalf/successHalfGoProduct.vue'),
    meta: {
      title: '闪借花',
    },
  },
  // iframe页面，用于显示外部链接
  {
    path: '/appFrame',
    name: 'AppFrame',
    component: () => import('../views/appFrame'),
    meta: {
      title: '第三方链接',
    },
  },
  // iframe页面，用于甜瓜 yinxin
  {
    path: '/tgFrame',
    name: 'tgFrame',
    component: () => import('../views/tgFrame'),
    meta: {
      title: '甜瓜iframe',
    },
  },
  // 机构详情页面
  {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('../views/productDetail/index'),
    meta: {
      title: '机构详情',
    },
  },
  // 产品详情页（新版，支持申请借款匹配流程）
  {
    path: '/productDetailNew',
    name: 'ProductDetailNew',
    component: () => import('../views/productDetail/product_detail_new'),
    meta: {
      title: '产品详情',
    },
  },
  // 进件成功结果页多个产品
  {
    path: '/result_multiple_products',
    name: 'result_multiple_products',
    component: () => import('../views/resultPages/result_multiple_products'),
    meta: {
      title: '等待电话审核',
    },
  },

  // 半流程表单页面
  {
    path: '/registerEntry_blc',
    name: 'RegisterEntryBlc',
    component: () => import('../views/entryPages/registerEntry_blc'),
    meta: {
      title: '草船借钱',
    },
  },
  // 暂无匹配产品页面
  {
    path: '/results_empty',
    name: 'ResultsEmpty',
    component: () => import('../views/resultPages/results_empty'),
    meta: {
      title: '暂无匹配产品',
    },
  },
  // 京东下载页
  {
    path: '/downloadApp_jd',
    name: 'downloadApp_jd',
    component: () => import('../views/resultPages/downloadApp_jd'),
    meta: {
      title: 'youjie',
    },
  },

  // // 联登全流程loading页面
  // {
  //   path: "/loading",
  //   name: "loadingPage",
  //   component: () => import("../views/Loading/index.vue"),
  //   meta: {
  //     title: "闪借花",
  //   },
  // },
  // // 联登全流程进入页面
  // {
  //   path: "/combinedWhole",
  //   name: "combinedWhole",
  //   component: () => import("../views/combinedWhole/entryWhole.vue"),
  //   meta: {
  //     title: "闪借花",
  //   },
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
})
router.beforeEach((to, from, next) => {
  var timestamp = new Date().getTime()
  to.query.tsp = timestamp
  next()
})
export default router
